import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-41",
  "use": "icon-button_icon-41-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-41\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><circle cx=\"11.008\" cy=\"9.951\" r=\"6.944\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.078 9.614L9.966 12l3.956-4\" /><path stroke-linecap=\"round\" d=\"M15.823 16.153l4.104 4.104\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol